import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { PageHead } from "../GtaxShell";
import { LEGAL } from "../legal";

const useTerms = (on) => {
  const [d, setD] = useState(null);
  useEffect(() => {
    if (on) axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/gtax/agreement`).then(({ data }) => setD(data)).catch(() => {});
  }, [on]);
  return d;
};

export default function GtaxLegal({ doc }) {
  const params = useParams();
  const key = doc || params.doc;
  const terms = useTerms(key === "terms");
  const d = key === "terms" && terms ? { ...LEGAL.terms, eyebrow: `Digital Agreement · ${terms.version}`, sections: terms.sections } : LEGAL[key];
  return (
    <div data-testid={`gtax-legal-${key}`}>
      <PageHead eyebrow={d.eyebrow} title={d.title} sub="DFI Holdings · GTA X — Gold Trading Association · Version 2.0" />
      <section className="pb-28">
        <div className="gx-wrap max-w-4xl gx-legal space-y-10">
          {d.sections.map(([h, ...ps]) => (
            <div key={h} className="gx-line pt-8">
              <h2 className="gx-caps text-xl">{h}</h2>
              {ps.map((p) => <p key={p.slice(0, 30)} className="mt-4 text-[color:var(--mute)] leading-relaxed">{p}</p>)}
            </div>
          ))}
          {terms?.schedule && key === "terms" && (
            <div className="gx-line pt-8" data-testid="gtax-legal-schedule">
              <h2 className="gx-caps text-xl">Schedule · Tiers</h2>
              <table className="w-full mt-4 text-sm"><tbody>{terms.schedule.map((r) => <tr key={r[0]} className="border-b border-[color:var(--line)]">{r.map((c) => <td key={c}>{c}</td>)}</tr>)}</tbody></table>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
